/**
 * 🌍 v6.63 (Lighthouse pass 4): only English ships in the entry chunk.
 * This resolves the player's language (stored choice, else the browser's)
 * and awaits that language's dictionaries BEFORE the app mounts, so a
 * Spanish or French player never sees an English flash - one extra small
 * request for them, ~130 KB less JavaScript for everyone.
 */
export default defineNuxtPlugin(async () => {
  const { locale, load, loadDictionary } = useLocale()
  load()
  await loadDictionary(locale.value)
})
